import { isDateInRange } from 'ecs-react-components/dist/index.es';

export const filter = (notes, filters) => {
  const filteredNotes = notes.map((n) => {
    const note = n;
    note.isFiltered = false;

    if (!isDateInRange(filters.date, note.serviceDate)) {
      note.isFiltered = true;
      return note;
    }

    if (note.documentType !== filters.documentType && filters.documentType !== '') {
      note.isFiltered = true;
      return note;
    }

    if (note.authoredBy !== filters.authoredBy && filters.authoredBy !== '') {
      note.isFiltered = true;
      return note;
    }

    return note;
  });
  return filteredNotes;
};
